import React, { useEffect } from "react";
import { connect } from "react-redux";
import { fetchVipTiers } from "../../actions/merchantActions";
import VipTierItem from "./VipTierItem";

const VipTierSection = ({ merchantData, appStateData, fetchVipTiers }) => {
  let { shopDomain } = appStateData;
  let { vipTeirs, merchant } = merchantData;

  useEffect(() => {
    fetchVipTiers(shopDomain);
  }, []);

  return (
    <div className="vipTiers-section-wrapper">
      <div className="vipTiers-heading-container">
        <h2 className="vipTiers-heading">
          {merchant?.currentPlan?.planName !== "free" &&
          merchant?.customWidgetTheme?.textCustomization
            ? merchant?.customWidgetTheme?.textCustomization?.vipTiers
            : "VIP Tiers"}
        </h2>
      </div>
      <div className="vipTiers-items-warpper">
        {vipTeirs?.map((vipTeir, i) => (
          <VipTierItem key={i} vipTeir={vipTeir} />
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  merchantData: state.MerchantReducer,
  customerData: state.CustomerReducer,
  appStateData: state.AppstateReducer,
});

const mapDispatchToProps = (dispatch) => ({
  fetchVipTiers: (shopDomain) => dispatch(fetchVipTiers(shopDomain)),
});

export default connect(mapStateToProps, mapDispatchToProps)(VipTierSection);
